<template>
    <div class="w-full">
       <div class="w-full md:w-1/2 mx-auto">
           <div class="w-full h-64 mt-10">
            <h1 class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5" >
                Tahap 1 - Biodata
            </h1>
            <PersonMobile2 class="w-full h-full"/> 
           </div>
           <div class="w-full"> 
               <form @submit.prevent="check_pasien" class="mt-16">
                  <FlashMessage class="mt-5 mb-5"/>
                   <div class="w-full">
                       <TextInput v-model="form.no_rm" :error="form.errors.no_rm" class="w-full" id="no_rm" label="Nomor Rekam Medis / NIK" type="text"/>
                   </div>
                   <div class="w-full mt-5">
                       <DateInput v-model="form.tgl_lahir" :error="form.errors.tgl_lahir"  class="w-full" id="tgl_lahir" label="Tanggal Lahir" type="text"/>
                   </div>
                   <div class="w-full mt-5">
                       <button type="submit" class="bg-primary hover:bg-primary-dark h-16 rounded-3xl mt-8 w-full text-white m-auto" >
                           CARI
                       </button>
                   </div>
               </form>
           </div>
       </div>
   </div>
</template>

<script>
   import { Link } from '@inertiajs/inertia-vue3'
   import LayoutNoHeader from '../../Shared/LayoutNoHeader.vue'
   import PersonMobile2 from '../../Shared/PersonMobile2.vue'
   import TextInput from '../../Shared/TextInput.vue';
   import DateInput from '../../Shared/DateInput.vue';
   import FlashMessage from '../../Shared/FlashMessage.vue';
   export default{
       components: {
           PersonMobile2,
           TextInput,
           DateInput,
           Link,
           FlashMessage
       },
       layout: LayoutNoHeader,
       data(){
           return {
               form: this.$inertia.form({
                   no_rm: '',
                   tgl_lahir: ''
               })
           }
       },
       methods: {
           check_pasien(){
               this.form.post('/pasien/check_valid',{preserveScroll: true})
           }
       }
   }

</script>